import { Button, Card, Col, notification, Row } from "antd";
import { VFC } from "react";

export const CookieCard: VFC<{
  onChangeCookieValue: (value: "all" | "some") => void;
}> = ({ onChangeCookieValue }) => {
  return (
    <Card title={"Cookie Einstellungen"}>
      <Row gutter={[8, 16]}>
        <Col span={24}>
          Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren und
          die Zugriffe auf unsere Website zu analysieren um dadurh die Website
          besser zu machen. Außerdem geben wir Informationen zu Ihrer Verwendung
          unserer Website an unsere Partner für soziale Medien, Werbung und
          Analysen weiter. Unsere Partner führen diese Informationen
          möglicherweise mit weiteren Daten zusammen, die Sie ihnen
          bereitgestellt haben oder die sie im Rahmen Ihrer Nutzung der Dienste
          gesammelt haben.
        </Col>

        <Col xl={10} xxl={8} md={12} span={24}>
          <Button
            size={"large"}
            style={{
              color: "#b2b2b2",
              fontSize: 12,
              borderColor: "#eaeaea",
              borderWidth: 1,
            }}
            block
            type={"ghost"}
            onClick={() => {
              onChangeCookieValue("some");
              notification.info({
                message: "Cookie Einstellung gespeichert.",
              });
            }}
          >
            Nur die essenziellen Cookies akzeptieren.
          </Button>
        </Col>
        <Col xxl={16} xl={14} md={12} span={24}>
          <Button
            block
            size={"large"}
            onClick={() => {
              onChangeCookieValue("all");
            }}
            type={"primary"}
          >
            Alle zulassen
          </Button>
        </Col>
      </Row>
    </Card>
  );
};
